import * as React from "react";
import { Text } from "@uikit";
import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/outline";

interface IProps {
  page: number;
  mode: "simple" | "full";
  totalPages: number;
  totalItems: number;
  pageSize: number;
  handlePagination: (page: number) => void;
}

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(" ");
}

const Pagination = ({
  page,
  totalPages,
  mode,
  totalItems,
  pageSize,
  handlePagination,
}: IProps) => {
  let itemClass = `group p-2 w-8 h-8 flex items-center justify-center rounded-[6px] cursor-pointer hover:!bg-blue `;
  if (totalPages === 1) return <div className="mb-10"></div>;
  return (
    <div
      className={`flex ${
        mode === "simple" ? "justify-center" : "justify-between"
      } items-center `}
    >
      {mode === "full" && (
        <Text size={15} weight="semibold">
          Showing {pageSize * page - pageSize + 1} to{" "}
          {totalItems < pageSize * page ? totalItems : pageSize * page} of{" "}
          {totalItems}
        </Text>
      )}
      <div className="flex gap-1">
        {page !== 1 && (
          <div
            className={classNames(itemClass, "bg-white border border-grey3")}
            onClick={() => handlePagination(page - 1)}
          >
            <ChevronLeftIcon className="w-5 group-hover:!text-white" />
          </div>
        )}
        <div
          className={classNames(
            page === 1 && "!bg-blue",
            itemClass,
            "bg-white border border-grey3"
          )}
          onClick={() => handlePagination(1)}
        >
          <Text
            size={15}
            weight="semibold"
            color={page === 1 ? "white" : "black"}
            className={classNames("m-0 p-0 group-hover:!text-white")}
          >
            {1}
          </Text>
        </div>
        {page > 3 && (
          <div
            className={classNames(itemClass, "bg-white border border-grey3")}
          >
            <div className=" group-hover:!text-white">...</div>
          </div>
        )}
        {page === totalPages && totalPages > 3 && (
          <div
            className={classNames(itemClass, "bg-white border border-grey3")}
            onClick={() => handlePagination(page - 2)}
          >
            <Text
              size={15}
              weight="semibold"
              className="m-0 p-0 group-hover:!text-white"
            >
              {page - 2}
            </Text>
          </div>
        )}
        {page > 2 && (
          <div
            className={classNames(itemClass, "bg-white border border-grey3")}
            onClick={() => handlePagination(page - 1)}
          >
            <Text
              size={15}
              weight="semibold"
              className="m-0 p-0 group-hover:!text-white"
            >
              {page - 1}
            </Text>
          </div>
        )}
        {page !== 1 && page !== totalPages && (
          <div
            className={classNames(itemClass, "bg-blue text-white")}
            onClick={() => handlePagination(page)}
          >
            <Text size={15} weight="semibold" className="m-0 p-0" color="white">
              {page}
            </Text>
          </div>
        )}
        {page < totalPages - 1 && (
          <div
            className={classNames(itemClass, "bg-white border border-grey3")}
            onClick={() => handlePagination(page + 1)}
          >
            <Text
              size={15}
              weight="semibold"
              className="m-0 p-0 group-hover:!text-white"
            >
              {page + 1}
            </Text>
          </div>
        )}
        {page === 1 && totalPages > 3 && (
          <div
            className={classNames(itemClass, "bg-white border border-grey3")}
            onClick={() => handlePagination(page + 2)}
          >
            <Text
              size={15}
              weight="semibold"
              className="m-0 p-0 group-hover:!text-white"
            >
              {page + 2}
            </Text>
          </div>
        )}
        {page < totalPages - 2 && (
          <div
            className={classNames(itemClass, "bg-white border border-grey3")}
          >
            <div className=" group-hover:!text-white">...</div>
          </div>
        )}

        <div
          className={classNames(
            page === totalPages && "!bg-blue",
            itemClass,
            "bg-white border border-grey3"
          )}
          onClick={() => handlePagination(totalPages)}
        >
          <Text
            size={15}
            weight="semibold"
            color={page === totalPages ? "white" : "black"}
            className={classNames("m-0 p-0 group-hover:!text-white")}
          >
            {totalPages}
          </Text>
        </div>

        {page !== totalPages && (
          <div
            className={classNames(itemClass, "bg-white border border-grey3")}
            onClick={() => handlePagination(page + 1)}
          >
            <ChevronRightIcon className="w-5 group-hover:!text-white" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Pagination;
